import LoLExaminations from './LoLExaminations';

export default LoLExaminations;
